module.exports = __webpack_public_path__ + "static/img/ad8-1.f24ef1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark40/ad8-1.png
// module id = xAvm
// module chunks = 12